import {
  ControllerFieldState,
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

import {
  DateFormType,
  DateTimeFormType,
  NumericFormType,
  SelectFormTypeV2,
  SwitchFormType,
  TextAreaFormType,
  TextFormType,
  TinyMCEFormType,
  UploadFileFormType,
} from "@utils/types/components";

export interface FormInputControllerProps<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields> {
  renderInput: (body: {
    onChange: (...event: any[]) => void;
    onBlur: () => void;
    ref: any;
    value: any | undefined;
    isError: boolean;
    fieldState: ControllerFieldState;
    // props: Partial<FormInputControllerProps<TFormFields>>;
  }) => JSX.Element;
  fieldMeta:
    | TextFormType
    | TextAreaFormType
    | TinyMCEFormType
    | DateTimeFormType
    | DateFormType
    | UploadFileFormType
    | SwitchFormType
    | NumericFormType
    | SelectFormTypeV2;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
}

export const FormInputController = <TFormFields extends FieldValues>({
  renderInput,
  fieldMeta,
  validationErrorMessages = {
    required: "This field is required",
    pattern: "This field is invalid",
    minLength: "This field should be longer",
    maxLength: "This field should be shorter",
  },
  ...props
}: FormInputControllerProps<TFormFields>) => {
  const {
    field: { name, ...otherFields },
    fieldState,
  } = useController({
    ...props,
    rules: {
      required: {
        message: validationErrorMessages?.required || "",
        value: fieldMeta.required || false,
      },
      pattern: {
        message: validationErrorMessages?.pattern || "",
        value: fieldMeta.fieldOptions?.pattern || /^.*$/,
      },
      minLength: {
        message: validationErrorMessages?.minLength || "",
        value: fieldMeta.fieldOptions?.minLength || 0,
      },
      maxLength: {
        message: validationErrorMessages?.maxLength || "",
        value: fieldMeta.fieldOptions?.maxLength || 999999999,
      },
      ...props.rules,
    },
  });

  const isError = fieldState.error;

  return renderInput({
    ...otherFields,
    isError: Boolean(isError),
    fieldState,
  });
};
